<template lang='pug'>
  .modal-body
    slot
</template>

<script>

export default {
  props: {
  }
}
</script>

<style lang='less'>
  .modal-body {
    padding: 15px;
    position: relative;
    height: ~"calc(100% - 55px)";
    overflow: auto;
  }
</style>